import { IDrive } from '../DriveBase/types';

export interface IDriveThreeSpeed extends IDrive {
    isStep1: boolean;
    isStep2: boolean;
    isStep3: boolean;
}

export const schema = 'AutomationApps.Devices.Drives.DriveThreeSpeed';
export const schemaFan = 'AutomationApps.Devices.Drives.FanThreeSpeed';